import { FC, HTMLAttributes } from 'react';

import { Alert, Button, Flex, Typography } from 'antd';
import cn from 'classnames';

import { formatNumber } from 'shared/utils';

import { useBalance } from '../../hooks/useBalance';
import { BalanceItem } from '../BalanceItem/BalanceItem';

import styles from './Balance.module.scss';

interface IBalanceProps extends HTMLAttributes<HTMLDivElement> {
	isPublisher?: boolean;
	type?: 'short' | 'extend';
}

export const Balance: FC<IBalanceProps> = ({ className, type = 'short', isPublisher, ...props }) => {

	const {
		t,
		// appConfig,
	} = useBalance();

	// if (!appConfig?.user?.balance) {
	// 	return null;
	// }

	// const {
	// 	user: {
	// 		balance: { balance_amount, on_hold_amount, currency },
	// 		// balance: { approved_amount, balance_amount, on_hold_amount, currency },
	// 	},
	// } = appConfig;

	const balance_amount = isPublisher ? '234' : '2605';
	const on_hold_amount = '10309';
	const currency = 'USD';
	const balanceStyle = isPublisher ? 'balancePub' : 'balance';

	if (type === 'short') {

		return (
			<div {...props} className={cn(className, styles.short)}>
				<Typography.Text className={styles.title}>
					{t('Balance')}
				</Typography.Text>
				<Typography.Text className={styles[balanceStyle]} strong>
					{formatNumber(balance_amount)} {currency}
				</Typography.Text>
			</div>
		);
	}

	if (type === 'extend') {
		return (
			<Flex vertical gap={8}>
				<div {...props} className={cn(className, styles.extend)}>
					<BalanceItem type="available" balance={balance_amount} currency={currency}/>
					<BalanceItem
						type="awaiting"
						balance={on_hold_amount}
						currency={currency} />

					<div className={styles.buttons}>
						<Button type='primary' block disabled>{t('Pay all contractors (soon)')}</Button>
						<Button type='primary' block disabled>{t('Top-up balance (soon)')}</Button>
					</div>
				</div>
				<Alert type='warning' showIcon title={t('No payment required here yet. Paid via Admitad CPA invoice as a separate transaction.')}/>
			</Flex>
		);
	}
};
